<template>
  <div class="container">
    <content-title :nav="nav"></content-title>
    <el-form :inline="true">
      <el-form-item label="序列号" >
        <el-input v-model="query.device_id" placeholder="设备序列号"></el-input>
      </el-form-item>
      <el-form-item label="设备类型">
        <el-select v-model="query.device_code" placeholder="请选择">
          <el-option
            v-for="item in deviceCode"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="设备状态">
        <el-select v-model="query.active_status" placeholder="请选择">
          <el-option
            v-for="item in activeStatusType"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="品牌">
        <el-select v-model="query.brand_id" placeholder="请选择">
          <el-option
            v-for="item in brandList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getList(1)">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="success" @click="openAdd">添加设备</el-button>
      </el-form-item>
    </el-form>
    <auto-table
      :DataList="DataList"
      :option="Option"
      :total="Total"
      @changePage="getList"
    >
      <template #code="{ row }">
        <div>
          {{ getNameByValue(deviceCode, row.device_code) }}
        </div>
      </template>
      <template #status="{ row }">
        <div>
          <el-tag type="success" v-if="row.active_status == 1">在线</el-tag>
          <el-tag type="info" v-else>离线</el-tag>
        </div>
      </template>
      <template #edit="{ row }">
        <el-button type="primary" size="small" @click="editDevice(row)">编辑设备</el-button>
         <el-button type="success"  size="small" @click="toDetails(row)">设备详情</el-button>
      </template>
    </auto-table>

    <addDevice ref="editRef" @success="getList(1)"></addDevice>
  </div>
</template>

<script>
import { deviceCode,activeStatusType } from "@/views/deviceManage/components/dict";
import addDevice from "./components/device/addDevice.vue";
export default {
  components: {
    addDevice,
  },
  data() {
    return {
      nav: { firstNav: "设备中心", secondNav: "设备列表" },
      deviceCode,
      activeStatusType,
      DataList: [],
      brandList:[],
      Option: [
        { name: "名称", value: "device_name" },
        { name: "序列号", value: "device_id" },
        { name: "状态", value: "status",type: "custom" },
        { name: "类型", value: "code", type: "custom" },
        { name: "添加时间", value: "create_time" },
        { name: "操作", value: "edit", type: "custom" },
      ],
      Total: 0,
      status: 1,
      query: {},
    };
  },

  mounted() {
    this.getList(1);
    this.getBrand();
  },
  methods: {
    editDevice(row) {
      this.$refs.editRef.open(row);
    },
    openAdd() {
      this.$refs.editRef.open();
    },
    toDetails(row){
      this.$router.push({name:'device',query:{id:row.device_id}})
    },
    getBrand() {
      this.$axios({
        url: "/device/deviceBrand/queryListPage",
        params: { pageSize: 50 },
      }).then((res) => {
        this.brandList = res.data.data;
      });
    },
    //获取列表
    getList(v) {
      let page = v || 1;
      this.$axios({
        url: "/device/device/queryManagerListPage",
        params: {
          currentPage: page,
          pageSize: 10,
          ...this.query,
        },
      }).then((res) => {
        this.DataList = res.data.data.rows;
        this.Total = res.data.data.total;
      });
    },
  },
};
</script>

<style lang="less" scoped>
</style>